import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogModel } from '../../../../shared/components/dialog/dialog';
import { LanguageService } from '../../../../core/services/language.service';
import { CurrencyPipe } from '@angular/common';

interface ConfirmationDialogData {
  quantity: number;
  immediatePayment: number;
  yearlyPayment: number;
  isFreeTrial: boolean;
  onConfirm: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class SubscriptionDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly languageService = inject(LanguageService);
  private readonly currencyPipe = inject(CurrencyPipe);

  showConfirmationDialog(data: ConfirmationDialogData) {
    const upgradeConfirmationDialog = new DialogModel(this.dialog);
    upgradeConfirmationDialog.closable = true;
    upgradeConfirmationDialog.headline =
      this.languageService.translateOnRuntime(
        'portal.settings.billingSettings.upgradeConfirmationDialog.headline',
      );

    const descriptionKey = data.isFreeTrial
      ? 'portal.settings.billingSettings.upgradeConfirmationDialog.descriptionFreeTrial'
      : 'portal.settings.billingSettings.upgradeConfirmationDialog.description';

    const immediatePayment = this.currencyPipe.transform(
      (data.immediatePayment / 100).toFixed(2),
      'EUR',
      'symbol',
      '1.2-2',
      'de-DE',
    );
    const yearlyPayment = this.currencyPipe.transform(
      (data.yearlyPayment / 100).toFixed(2),
      'EUR',
      'symbol',
      '1.2-2',
      'de-DE',
    );

    upgradeConfirmationDialog.description =
      this.languageService.translateOnRuntime(descriptionKey, {
        immediatePayment,
        yearlyPayment,
      });

    const submitButtonKey = data.isFreeTrial
      ? 'portal.settings.billingSettings.upgradeConfirmationDialog.submitButtonFreeTrial'
      : 'portal.settings.billingSettings.upgradeConfirmationDialog.submitButton';

    upgradeConfirmationDialog.buttonRowData = {
      confirmButtonText:
        this.languageService.translateOnRuntime(submitButtonKey),
      confirmButtonAction: data.onConfirm,
      declineButtonText: this.languageService.translateOnRuntime(
        'portal.settings.billingSettings.upgradeConfirmationDialog.abort',
      ),
    };

    upgradeConfirmationDialog.openDialog();

    return upgradeConfirmationDialog;
  }
}
